import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";


const BASE_URL = window.serverData.data.portalAPIURL;

/**
 * Returns consent recorded for the given user.
 * 
 * @param {any} key the consent to search for (ie FLU = flu vaccine consent)
 * @param {any} token the user token
 * 
 * @returns {any} consent model
 */
export const getConsent = (key, token) => {
    const fullUrl = `${BASE_URL}/api/consent/get?ConsentStringKey=${key}`;

    let params = {
        headers: {
            authorization: `bearer ${token}`
        },
        method: "GET"
    };
    
    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Profile.Consent.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Profile.Consent.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};


/**
 * Records a user's consent.
 * 
 * @param {any} key the consent to record (ie FLU = flu vaccine consent)
 * @param {any} value the true/false consent value
 * @param {any} token the user token
 * 
 * @returns {any} consent
 */
export const postConsent = (key, value, token) => {
    const fullUrl = `${BASE_URL}/api/consent/post`;
    let body = JSON.stringify({ "Approved": value, "ConsentStringKey": key });
    
    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json",
            "Content-Type": "application/json"
        },
        method: "POST",
        body: body
    };
    
    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Profile.Consent.Post", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Profile.Consent.Post.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getConsentList = (token) => {
    const fullUrl = `${BASE_URL}/api/consent/list`;

    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Profile.ConsentList.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Profile.ConsentList.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getConsentTypeList = (token) => {
    const fullUrl = `${BASE_URL}/api/consentType/list`;

    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Profile.ConsentTypeList.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Profile.ConsentTypeList.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });
};

export const getConsentType = (token, key) => {
    const fullUrl = `${BASE_URL}/api/consentType/get?ConsentStringKey=${key}`;

    const params = {
        headers: {
            "Authorization": `bearer ${token}`,
            "accept": "application/json"
        },
        method: "GET"
    };

    var start = new Date();

    return fetch(fullUrl, params)
        .then(response => {
            logAPI("MBHWeb.Api.Profile.ConsentType.Get", start, fullUrl);
            return response.json();
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Profile.ConsentType.Get.Failure", start, fullUrl);
            return Promise.reject(err);
        });

};
